import axios from 'axios';

// Configuração de ambientes - USAR BACKEND INTEGRADO
const getAuthBase = () => {
  const hostname = window.location.hostname;
  
  // Desenvolvimento local
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:3000'; // Backend integrado na mesma porta
  }
  
  // Em desenvolvimento/produção, usar o MESMO domínio (backend integrado)
  // Não usar o backend externo higher-fees-server
  return ''; // Mesmo domínio do frontend
};

export function loginStatic(payload) {
  const AUTH_BASE = getAuthBase();
  const url = `${AUTH_BASE}/auth/login`;
  console.log('🔐 Login URL:', url);
  console.log('🌍 Hostname:', window.location.hostname);
  return axios.post(url, payload);
}

const AuthStaticService = { loginStatic };

export default AuthStaticService;


